exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".basic-bar-position[data-v-24e4dbb8]{-webkit-transform:translateX(-50%);transform:translateX(-50%)}.basic-bar-item .item-info .iconfont[data-v-24e4dbb8]{color:#0784fa}", ""]);

// exports
